import mediaTypeIds from '../constants/media-type-ids';
import { getImage, getIframe } from './get-media';

const getMediaTypeId = (element) => {
  if (getImage(element)) {
    return mediaTypeIds.IMAGE;
  }

  if (getIframe(element)) {
    return mediaTypeIds.VIDEO;
  }

  return null;
};

export default getMediaTypeId;
